import React, { useState } from "react";
import DCard from "../components/DCard";
//import utils
import { toast } from "react-hot-toast";
import { useQuery, useQueryClient } from "react-query";
import DButton from "../components/DButton";
import { useSelector } from "react-redux";
import telegramServices from "../services/telegram";
import PageHeading from "../components/PageHeading";
import DSpinner from "../components/DSpinner";
import userServices from "../services/users";

const TelegramAccount = ({ title }) => {
  const queryClient = useQueryClient();
  document.title = title;
  const { auth } = useSelector((state) => state.config);
  const value = auth.username;

  const { data, isLoading, error } = useQuery(["getMyInfo"], () =>
    userServices.getMyInfo()
  );
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [telegramLink, setTelegramLink] = useState("");
  const linkTelegramAccountHandler = () => {
    setIsSubmitting(true);
    telegramServices
      .linkAccount()
      .then((res) => {
        setTelegramLink(res.data.link);
        toast.success("تم الربط بنجاح");
        setTimeout(() => {
          //   navigate(`/${res.data.link}`, { replace: true });
        }, 1500);
        queryClient.refetchQueries("getMyInfo");
      })
      .catch((err) => {
        if (err?.response?.status === 400) {
          toast.error("حسابك مربوط بالفعل");
        } else {
          toast.error("حصل خطأ بالسيرفر");
        }
      });
    setIsSubmitting(false);
  };
  const unlinkTelegramAccountHandler = () => {
    telegramServices
      .unlinkAccount()
      .then((res) => {
        toast.success("تم إلغاء الربط بنجاح");
        setTimeout(() => {
          //   navigate(`/${res.data.link}`, { replace: true });
        }, 1500);
        queryClient.refetchQueries("getMyInfo");

      })
      .catch((err) => {
        toast.error("حصل خطأ بالسيرفر");
      });
  };

  return (
    <div>
      <PageHeading>{title}</PageHeading>
      {isLoading ? (
        <DSpinner />
      ) : (
        <DCard className={"min-h-[200px] max-w-[800px] mx-auto"}>
          {data.data.data.telegram_id ? (
            <div>
              <div className="flex flex-col justify-between items-center gap-4">
                <p className="text-xl text-center text-primary-color-500 font-bold ">
                  عند إلغاء ربط حسابك لا تقلق يمكنك إعادة ربط حسابك مرة أخرى
                </p>
                <div>
                  <DButton
                    onClick={() => {
                      unlinkTelegramAccountHandler();
                    }}
                    bgColor="danger"
                    className=" text-white"
                  >
                    إلغاء ربط الحساب
                  </DButton>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <div className="flex flex-col justify-between items-center gap-4">
                <p className="text-xl text-primary-color-500 font-bold ">
                  يمكنك ربط حسابك الخاص على المتجر بحساب تلغرام لزيادة أمان
                  حسابك
                </p>
        
                <DButton
                  onClick={() => {
                    linkTelegramAccountHandler();
                  }}
                  bgColor="success"
                  className=" text-white"
                >
                  {isSubmitting ? <DSpinner /> : "ربط الحساب"}
                </DButton>
                {telegramLink ? (
                  <div>
                    <div>
                      رابط التفعيل:
                      <a
                        href={telegramLink}
                        className=" underline text-primary-color-500 font-bold "
                      >
                        {telegramLink}
                      </a>
                    </div>

                    <div className=" mt-2 text-red-500 ">
                      تنهتي صلاحية رابط التفعيل بعد 120 ثانية
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          )}
        </DCard>
      )}
    </div>
  );
};

export default TelegramAccount;
